/**
 * GROW PARIS — Sélecteur de pack PDP (offre dégressive 1 / 2 / 3 paires)
 *
 * Pilote le bouton d'ajout au panier existant (#gpdp-atc / #gpdp-sticky-atc)
 * sans le réécrire : le libellé est encapsulé dans un span dédié, le prix est
 * réinjecté dans #gpdp-atc-price, et le clic n'est intercepté (phase de
 * capture) que lorsqu'un pack de 2 ou 3 paires est sélectionné.
 *
 * Pack de N paires : le modèle affiché + N-1 paires au choix. Une case laissée
 * vide reprend le modèle affiché. Toutes les lignes partent au panier en un
 * seul appel, sans propriété particulière.
 *
 * ⚠️ La remise n'est PAS appliquée ici : elle vient des remises automatiques
 * « Pack 2 paires » / « Pack 3 paires » côté Shopify (data-off-2 / data-off-3
 * doivent leur correspondre).
 */
(function () {
  var root = document.querySelector('[data-pack-selector]');
  if (!root) return;

  var gpdpRoot = document.querySelector('[data-gpdp]');
  var CURRENCY = (gpdpRoot && gpdpRoot.dataset.currency) || 'EUR';

  var VARIANTS = [];
  try {
    VARIANTS = JSON.parse((gpdpRoot && gpdpRoot.dataset.variants) || '[]');
  } catch (e) {
    VARIANTS = [];
  }

  var MAX = 3;
  var mode = Math.min(MAX, Math.max(1, parseInt(root.dataset.defaultPack, 10) || 2));
  /* picks[i] = { vid, name, img } pour la case i+2 ; null = même modèle */
  var picks = [];
  var busy = false;

  var D = root.dataset;
  /* getAttribute : un chiffre après le tiret (data-off-2) n'est pas converti
     en camelCase par dataset, D.off2 vaudrait undefined. */
  var OFF = {
    1: 0,
    2: parseInt(root.getAttribute('data-off-2'), 10) || 0,
    3: parseInt(root.getAttribute('data-off-3'), 10) || 0
  };
  var errEl = root.querySelector('[data-pack-err]');
  var pickEl = root.querySelector('[data-pack-pick]');
  var slotsEl = root.querySelector('[data-pack-slots]');
  var mainName = D.mainName || '';
  var mainImg = D.mainImg || '';
  var STR = {
    perPair: D.strPerPair || '__PRICE__ / paire',
    /* getAttribute : dataset ne convertit pas un chiffre après le tiret (data-str-step-2). */
    step2: root.getAttribute('data-str-step-2') || '2e paire à <b>__P2__</b>',
    step3: root.getAttribute('data-str-step-3') || '2e paire à <b>__P2__</b> · 3e à <b>__P3__</b>',
    save: D.strSave || '−__AMOUNT__',
    cta: D.strCta || 'Ajouter mon pack',
    added: D.strAdded || '✓ Pack ajouté',
    same: D.strSame || 'Même modèle',
    remove: D.strRemove || 'Retirer',
    slot: D.strSlot || 'Paire __N__',
    yours: D.strYours || 'Ton choix',
    choose: D.strChoose || 'Choisis ta paire __N__',
    pick: D.strPick || 'Choisir',
    view: D.strView || 'Voir __NAME__',
    pvPick: D.strPvPick || 'Choisir pour la paire __N__',
    pvPicked: D.strPvPicked || '✓ Choisie pour la paire __N__',
    pvPage: D.strPvPage || 'Voir la fiche produit',
    close: D.strClose || 'Fermer',
    prev: D.strPrev || 'Précédent',
    next: D.strNext || 'Suivant'
  };
  var EYE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M1.5 12S5.5 5 12 5s10.5 7 10.5 7-4 7-10.5 7S1.5 12 1.5 12z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="12" cy="12" r="3.2" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';

  function eyeBtn(cls, handle, title) {
    return '<button type="button" class="' + cls + '" data-pack-eye data-handle="' + escapeHtml(handle) + '" data-name="' + escapeHtml(title) +
      '" aria-label="' + escapeHtml(STR.view.replace('__NAME__', title)) + '">' + EYE_SVG + '</button>';
  }
  /* Case en cours d'édition parmi les paires 2..N (index dans picks). */
  var activeSlot = 0;
  var GS = window.growStrings || {};

  function money(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: CURRENCY });
  }

  /* « 20 € » plutôt que « 20,00 € » : un prix rond se lit plus vite. */
  function moneyShort(cents) {
    var round = cents % 100 === 0;
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: CURRENCY, minimumFractionDigits: round ? 0 : 2, maximumFractionDigits: 2 });
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* « IBIZA - NOIR » → modèle en gras, coloris en dessous : évite les noms
     tronqués dans les petites vignettes. */
  function splitName(title) {
    var parts = String(title || '').split(' - ');
    return { model: parts[0], color: parts.slice(1).join(' - ').toLowerCase() };
  }

  function nameHtml(title, cls) {
    var n = splitName(title);
    return '<span class="' + cls + '__name">' + escapeHtml(n.model) + '</span>' +
      (n.color ? '<span class="' + cls + '__color">' + escapeHtml(n.color) + '</span>' : '');
  }

  function unitPrice() {
    var vid = window.GROW_SELECTED_VID;
    if (vid) {
      for (var i = 0; i < VARIANTS.length; i++) {
        if (VARIANTS[i].id === vid) return VARIANTS[i].price;
      }
    }
    return parseInt(D.unitPrice, 10) || 0;
  }

  function packTotal(n, unit) {
    return Math.max(0, unit * n - (OFF[n] || 0));
  }

  function ctaButtons() {
    var list = [];
    ['gpdp-atc', 'gpdp-sticky-atc'].forEach(function (id) {
      var b = document.getElementById(id);
      if (b) list.push(b);
    });
    return list;
  }

  /* Noms des paires du pack, case par case (vide = modèle affiché). */
  function slotNames() {
    var names = [mainName];
    for (var i = 0; i < mode - 1; i++) names.push(picks[i] ? picks[i].name : mainName);
    return names;
  }

  function summaryHtml() {
    var names = slotNames();
    var allSame = names.every(function (n) { return n === mainName; });
    if (allSame) return '<b>' + mode + ' ×&nbsp;' + escapeHtml(mainName) + '</b>';
    return names.map(function (n) { return '<b>' + escapeHtml(n) + '</b>'; }).join('<i>+</i>');
  }

  /* ---------- libellé du bouton ----------
     Le libellé est un nœud texte nu dans le Liquid. On l'encapsule une fois
     dans un span pour pouvoir le changer sans toucher au prix ni au chevron. */

  function ensureLabel(btn) {
    var span = btn.querySelector('[data-atc-label]');
    if (span) return span;

    /* Après buildNote(), le libellé est descendu dans .cta-main__line. */
    var host = btn.querySelector('.cta-main__line') || btn;
    var node = null;
    for (var i = 0; i < host.childNodes.length; i++) {
      var n = host.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) { node = n; break; }
    }
    if (!node) return null;

    span = document.createElement('span');
    span.setAttribute('data-atc-label', '');
    span.dataset.orig = node.textContent;
    span.dataset.base = (btn.dataset.label || node.textContent).trim();
    span.textContent = node.textContent;
    node.parentNode.replaceChild(span, node);
    return span;
  }

  function syncButtons() {
    var unit = unitPrice();

    ctaButtons().forEach(function (btn) {
      if (btn.disabled) return;
      var span = ensureLabel(btn);
      if (!span) return;
      span.textContent = mode > 1
        ? span.dataset.orig.replace(span.dataset.base, STR.cta)
        : span.dataset.orig;
    });

    var priceEl = document.getElementById('gpdp-atc-price');
    if (priceEl) {
      if (mode > 1) priceEl.innerHTML = '<s>' + money(unit * mode) + '</s> ' + money(packTotal(mode, unit));
      else priceEl.textContent = money(unit);
    }
  }

  /* ---------- note sous le bouton ---------- */

  /* Résolue à chaque passe : gpdp.js remplace l'innerHTML du bouton pendant
     son feedback « ✓ Ajouté », ce qui détacherait une référence mise en cache. */
  function noteEl() {
    var btn = document.getElementById('gpdp-atc');
    return btn ? btn.querySelector('.cta-main__note') : null;
  }

  function buildNote() {
    var btn = document.getElementById('gpdp-atc');
    if (!btn || btn.querySelector('.cta-main__note')) return;

    /* On regroupe le contenu Liquid existant (libellé + prix + chevron) sur
       une ligne, puis on ajoute la note comme 2e ligne du même bouton. */
    var line = document.createElement('span');
    line.className = 'cta-main__line';
    while (btn.firstChild) line.appendChild(btn.firstChild);
    btn.appendChild(line);

    var el = document.createElement('span');
    el.className = 'cta-main__note';
    el.hidden = true;
    btn.appendChild(el);
  }

  function syncNote() {
    var note = noteEl();
    if (!note) return;
    var btn = note.parentNode;

    if (mode === 1) {
      note.hidden = true;
      if (btn) btn.classList.remove('cta-main--noted');
      return;
    }
    note.hidden = false;
    if (btn) btn.classList.add('cta-main--noted');
    note.innerHTML = summaryHtml();
  }

  /* ---------- barre sticky ----------
     Elle n'affiche par défaut que le modèle courant : en mode pack c'est
     trompeur, puisque le clic envoie plusieurs paires. On y reflète donc le
     contenu du pack (badge ×N + noms) et son prix. */

  function syncSticky() {
    var nameEl = document.getElementById('gpdp-sticky-name');
    var priceEl = document.getElementById('gpdp-sticky-price');
    var media = document.getElementById('gpdp-sticky-media');
    if (!nameEl) return;

    if (nameEl.dataset.orig === undefined) nameEl.dataset.orig = nameEl.textContent.trim();

    var badge = media && media.querySelector('[data-sticky-x2]');
    var unit = unitPrice();

    if (mode === 1) {
      if (badge) badge.remove();
      nameEl.textContent = nameEl.dataset.orig;
      if (priceEl) priceEl.textContent = money(unit);
      return;
    }

    if (media && !badge) {
      badge = document.createElement('span');
      badge.className = 'sticky-cta__x2';
      badge.setAttribute('data-sticky-x2', '');
      media.appendChild(badge);
    }
    if (badge) badge.textContent = '×' + mode;
    nameEl.innerHTML = summaryHtml();
    if (priceEl) priceEl.innerHTML = '<s>' + money(unit * mode) + '</s> ' + money(packTotal(mode, unit));
  }

  /* ---------- composition du pack ---------- */

  /* Une carte par paire du pack. La 1re est le modèle affiché (fixe) ; les
     suivantes sont cliquables : la case active est celle que remplit le
     carrousel en dessous. */
  function renderSlots() {
    if (!slotsEl) return;
    slotsEl.className = 'pack-sel__slots pack-sel__slots--' + mode;
    var html = '';
    for (var i = 0; i < mode; i++) {
      var k = i - 1;
      var p = i === 0 ? null : picks[k];
      var img = p ? p.img : mainImg;
      var name = p ? p.name : mainName;
      var tag;
      if (i === 0) tag = '<span class="pack-slot__tag pack-slot__tag--ok">✓ ' + escapeHtml(STR.yours) + '</span>';
      else if (p) tag = '<span class="pack-slot__tag pack-slot__tag--ok">✓ ' + escapeHtml(STR.yours) + '</span>';
      else tag = '<span class="pack-slot__tag">' + escapeHtml(STR.same) + '</span>';

      var cls = 'pack-slot' +
        (i === 0 ? ' pack-slot--main' : '') +
        (i > 0 && !p ? ' pack-slot--same' : '') +
        (i > 0 && k === activeSlot ? ' is-active' : '');
      var attrs = i === 0 ? '' :
        ' role="button" tabindex="0" data-pack-slot="' + k + '" aria-pressed="' + (k === activeSlot) + '"';

      /* Une paire choisie (≠ modèle affiché) mène à sa fiche produit. */
      var body =
        '<span class="pack-slot__media">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="" width="120" height="120">' : '<span class="pack-thumb__ph"></span>') +
        '</span>' +
        nameHtml(name, 'pack-slot');
      if (p && p.handle) {
        body = '<a class="pack-slot__link" href="' + escapeHtml(cartRoot() + 'products/' + p.handle) + '">' + body + '</a>';
      }

      html += '<div class="' + cls + '"' + attrs + '>' +
        '<span class="pack-slot__eyebrow">' + escapeHtml(STR.slot.replace('__N__', i + 1)) + '</span>' +
        body +
        (p ? '<button type="button" class="pack-slot__rm" data-pack-rm="' + k + '" aria-label="' + escapeHtml(STR.remove + ' ' + p.name) + '">×</button>' : '') +
        eyeBtn('pack-slot__eye', p ? p.handle : (D.mainHandle || ''), name) +
        tag +
      '</div>';
    }
    slotsEl.innerHTML = html;

    var chooseEl = root.querySelector('[data-pack-choose]');
    if (chooseEl) chooseEl.textContent = STR.choose.replace('__N__', activeSlot + 2);
  }

  function syncThumbs() {
    /* La carte de la case active est « ✓ Paire N » (c'est elle qu'on édite) ; une paire
       déjà placée dans une autre case l'indique, pour qu'on sache où va chaque paire. */
    var slotOf = {};
    for (var k = 0; k < mode - 1; k++) {
      if (picks[k] && slotOf[picks[k].vid] === undefined) slotOf[picks[k].vid] = k;
    }
    var activeVid = picks[activeSlot] ? picks[activeSlot].vid : null;
    root.querySelectorAll('[data-pack-free]').forEach(function (t) {
      var vid = parseInt(t.dataset.vid, 10);
      var on = vid === activeVid;
      var used = !on && slotOf[vid] !== undefined;
      t.classList.toggle('is-on', on);
      t.classList.toggle('is-used', used);
      var hit = t.querySelector('.pack-thumb__hit');
      if (hit) hit.setAttribute('aria-pressed', on ? 'true' : 'false');
      var cta = t.querySelector('[data-pack-cta]');
      if (cta) {
        cta.textContent = on ? '✓ ' + STR.slot.replace('__N__', activeSlot + 2)
          : used ? STR.slot.replace('__N__', slotOf[vid] + 2)
          : STR.pick;
      }
    });
  }

  /* ---------- rendu ---------- */

  function sync() {
    var unit = unitPrice();
    picks.length = Math.min(picks.length, mode - 1);
    if (activeSlot > mode - 2) activeSlot = Math.max(0, mode - 2);

    root.querySelectorAll('.pack-opt').forEach(function (opt) {
      var n = parseInt(opt.dataset.pack, 10);
      var on = n === mode;
      opt.classList.toggle('is-on', on);
      var hit = opt.querySelector('.pack-opt__hit');
      if (hit) hit.setAttribute('aria-checked', on ? 'true' : 'false');

      var total = packTotal(n, unit);
      var el;
      if ((el = opt.querySelector('[data-pack-total]'))) el.textContent = money(total);
      if ((el = opt.querySelector('[data-pack-old]'))) el.textContent = money(unit * n);
      if ((el = opt.querySelector('[data-pack-per]'))) {
        /* Prix réellement payé pour chaque paire en plus, recalculé si le prix du coloris change. */
        var p2 = escapeHtml(moneyShort(packTotal(2, unit) - unit));
        var p3 = escapeHtml(moneyShort(packTotal(3, unit) - packTotal(2, unit)));
        el.innerHTML = (n === 2 ? STR.step2 : STR.step3).replace('__P2__', p2).replace('__P3__', p3);
      }
      if ((el = opt.querySelector('[data-pack-save]'))) el.textContent = STR.save.replace('__AMOUNT__', money(OFF[n] || 0));    });

    /* Le panneau de composition vit dans la carte sélectionnée : on voit
       tout de suite à quel pack se rapportent les paires choisies. */
    if (pickEl) {
      pickEl.hidden = mode === 1;
      var active = root.querySelector('.pack-opt.is-on');
      if (active && mode > 1 && pickEl.parentNode !== active) active.appendChild(pickEl);
    }
    renderSlots();
    syncThumbs();
    syncButtons();
    syncNote();
    syncSticky();
    /* Le picker est masqué en mode 1 : ses mesures ne valent qu'une fois visible. */
    syncScrollUi();
  }

  /* ---------- interactions ---------- */

  root.querySelectorAll('.pack-opt__hit').forEach(function (hit) {
    hit.addEventListener('click', function () {
      var opt = hit.closest('.pack-opt');
      if (!opt) return;
      mode = parseInt(opt.dataset.pack, 10) || 1;
      if (errEl) errEl.hidden = true;
      sync();
    });
  });

  /* Délégation : les vignettes ajoutées par l'hydratation sont couvertes. */
  root.addEventListener('click', function (e) {
    var eye = e.target.closest && e.target.closest('[data-pack-eye]');
    if (eye) {
      e.preventDefault();
      e.stopPropagation();
      var card = eye.closest('[data-pack-free]');
      pvOpen(eye.dataset.handle || (card && card.dataset.handle) || '',
        eye.dataset.name || (card && card.dataset.name) || '', card);
      return;
    }

    /* Lien vers la fiche d'une paire choisie : navigation normale. */
    if (e.target.closest && e.target.closest('.pack-slot__link')) return;

    /* Le bandeau « Le plus choisi / Meilleur prix » est hors du bouton : il
       sélectionne aussi l'option. */
    var flag = e.target.closest && e.target.closest('.pack-opt__flag');
    if (flag) {
      var hit = flag.parentNode.querySelector('.pack-opt__hit');
      if (hit) hit.click();
      return;
    }

    var arrow = e.target.closest && e.target.closest('[data-pack-prev], [data-pack-next]');
    if (arrow) {
      scrollThumbs(arrow.hasAttribute('data-pack-prev') ? -1 : 1);
      return;
    }

    var rm = e.target.closest && e.target.closest('[data-pack-rm]');
    if (rm) {
      e.stopPropagation();
      activeSlot = parseInt(rm.dataset.packRm, 10);
      picks[activeSlot] = null;
      sync();
      return;
    }

    var slot = e.target.closest && e.target.closest('[data-pack-slot]');
    if (slot) {
      activeSlot = parseInt(slot.dataset.packSlot, 10);
      sync();
      return;
    }

    var thumb = e.target.closest && e.target.closest('[data-pack-free]');
    if (!thumb) return;
    pickThumb(thumb);
  });

  function pickThumb(thumb) {
    if (mode === 1) return;

    var vid = parseInt(thumb.dataset.vid, 10);
    var slots = mode - 1;

    /* La paire déjà dans la case active : un 2e clic la remet au même modèle. */
    if (picks[activeSlot] && picks[activeSlot].vid === vid) {
      picks[activeSlot] = null;
    } else {
      var thumbImg = thumb.querySelector('img');
      picks[activeSlot] = {
        vid: vid,
        name: thumb.dataset.name || '',
        handle: thumb.dataset.handle || '',
        img: thumbImg ? thumbImg.currentSrc || thumbImg.src : ''
      };
      /* On enchaîne sur la case suivante encore au même modèle, s'il y en a. */
      for (var i = 1; i < slots; i++) {
        var next = (activeSlot + i) % slots;
        if (!picks[next]) { activeSlot = next; break; }
      }
    }
    if (errEl) errEl.hidden = true;
    sync();
  }

  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var slot = e.target.closest && e.target.closest('[data-pack-slot]');
    if (!slot || e.target !== slot) return;
    e.preventDefault();
    activeSlot = parseInt(slot.dataset.packSlot, 10);
    sync();
  });

  /* ---------- hydratation du carrousel ----------
     collection.products plafonne à 50 en Liquid. On complète avec le reste
     de la collection via l'endpoint public products.json. */

  function buildThumb(vid, title, imgSrc, handle) {
    var card = document.createElement('div');
    card.className = 'pack-thumb';
    card.setAttribute('data-pack-free', '');
    card.dataset.vid = vid;
    card.dataset.name = title;
    card.dataset.handle = handle;
    card.innerHTML = eyeBtn('pack-thumb__eye', handle, title);

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pack-thumb__hit';
    b.setAttribute('aria-pressed', 'false');
    card.appendChild(b);

    if (imgSrc) {
      var img = document.createElement('img');
      img.src = imgSrc;
      img.alt = title;
      img.loading = 'lazy';
      img.width = 120;
      img.height = 120;
      b.appendChild(img);
    } else {
      var ph = document.createElement('span');
      ph.className = 'pack-thumb__ph';
      b.appendChild(ph);
    }

    b.insertAdjacentHTML('beforeend', nameHtml(title, 'pack-thumb') +
      '<span class="pack-thumb__cta" data-pack-cta>' + escapeHtml(STR.pick) + '</span>');
    return card;
  }

  /* ---------- aperçu d'une paire (clic sur l'œil) ----------
     Fenêtre avec toutes les photos du modèle, son nom et son coloris. Ouverte depuis
     une carte du carrousel, elle permet aussi de choisir la paire pour la case active. */

  var pv = null;
  var pvThumb = null;
  var pvHandle = '';
  var pvLastFocus = null;
  var pvCache = {};

  function pvBuild() {
    if (pv) return pv;
    pv = document.createElement('div');
    pv.className = 'pack-pv';
    pv.hidden = true;
    pv.setAttribute('role', 'dialog');
    pv.setAttribute('aria-modal', 'true');
    pv.setAttribute('aria-labelledby', 'pack-pv-name');
    var arrow = function (dir, d) {
      return '<button type="button" class="pack-pv__arrow pack-pv__arrow--' + dir + '" data-pv-' + dir + ' aria-label="' + escapeHtml(dir === 'prev' ? STR.prev : STR.next) + '">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    };
    pv.innerHTML =
      '<div class="pack-pv__backdrop" data-pv-close></div>' +
      '<div class="pack-pv__panel">' +
        '<button type="button" class="pack-pv__close" data-pv-close aria-label="' + escapeHtml(STR.close) + '">×</button>' +
        '<div class="pack-pv__media">' +
          '<div class="pack-pv__gallery" data-pv-gallery></div>' +
          arrow('prev', 'M15 5l-7 7 7 7') + arrow('next', 'M9 5l7 7-7 7') +
        '</div>' +
        '<div class="pack-pv__dots" data-pv-dots></div>' +
        '<div class="pack-pv__body">' +
          '<p class="pack-pv__name" id="pack-pv-name" data-pv-name></p>' +
          '<p class="pack-pv__color" data-pv-color></p>' +
          '<button type="button" class="pack-pv__pick" data-pv-pick></button>' +
          '<a class="pack-pv__page" data-pv-page href="#"></a>' +
        '</div>' +
      '</div>';
    /* Dans .gpdp pour hériter des variables (couleurs, polices) de la fiche. */
    (gpdpRoot || document.body).appendChild(pv);

    var gallery = pv.querySelector('[data-pv-gallery]');
    pv.addEventListener('click', function (e) {
      if (e.target.closest('[data-pv-close]')) { pvClose(); return; }
      var a = e.target.closest('[data-pv-prev], [data-pv-next]');
      if (a) {
        gallery.scrollBy({ left: (a.hasAttribute('data-pv-prev') ? -1 : 1) * gallery.clientWidth, behavior: 'smooth' });
        return;
      }
      if (e.target.closest('[data-pv-pick]')) {
        /* Déjà choisie pour cette case : le bouton confirme simplement et ferme. */
        if (pvThumb && !pvThumb.classList.contains('is-on')) pickThumb(pvThumb);
        pvClose();
      }
    });
    gallery.addEventListener('scroll', pvSyncDots, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (pv.hidden) return;
      if (e.key === 'Escape') pvClose();
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        gallery.scrollBy({ left: (e.key === 'ArrowLeft' ? -1 : 1) * gallery.clientWidth, behavior: 'smooth' });
      }
    });
    return pv;
  }

  function pvRender(imgs, title) {
    var gallery = pv.querySelector('[data-pv-gallery]');
    gallery.innerHTML = imgs.map(function (src, i) {
      return '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(title) + '" width="900" height="900"' + (i ? ' loading="lazy"' : '') + '>';
    }).join('');
    gallery.scrollLeft = 0;
    var multi = imgs.length > 1;
    pv.querySelectorAll('.pack-pv__arrow').forEach(function (a) { a.hidden = !multi; });
    pv.querySelector('[data-pv-dots]').innerHTML = multi ? imgs.map(function () { return '<span></span>'; }).join('') : '';
    pvSyncDots();
  }

  function pvSyncDots() {
    if (!pv) return;
    var gallery = pv.querySelector('[data-pv-gallery]');
    var i = gallery.clientWidth ? Math.round(gallery.scrollLeft / gallery.clientWidth) : 0;
    pv.querySelectorAll('[data-pv-dots] span').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
  }

  function pvImages(handle) {
    if (pvCache[handle]) return Promise.resolve(pvCache[handle]);
    return fetch(cartRoot() + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var imgs = (p.images || []).map(function (src) {
          if (src.indexOf('//') === 0) src = 'https:' + src;
          return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=900';
        });
        pvCache[handle] = imgs;
        return imgs;
      })
      .catch(function () { return []; });
  }

  function pvOpen(handle, title, thumb) {
    if (!handle) return;
    pvBuild();
    pvThumb = thumb || null;
    pvHandle = handle;
    pvLastFocus = document.activeElement;

    var n = splitName(title);
    pv.querySelector('[data-pv-name]').textContent = n.model;
    var colorEl = pv.querySelector('[data-pv-color]');
    colorEl.textContent = n.color;
    colorEl.hidden = !n.color;

    var page = pv.querySelector('[data-pv-page]');
    page.href = cartRoot() + 'products/' + handle;
    page.textContent = STR.pvPage;
    /* La fiche affichée n'a pas besoin d'un lien vers elle-même. */
    page.hidden = handle === (D.mainHandle || '');

    var pick = pv.querySelector('[data-pv-pick]');
    var canPick = !!pvThumb && mode > 1;
    pick.hidden = !canPick;
    if (canPick) {
      var on = pvThumb.classList.contains('is-on');
      pick.classList.toggle('is-on', on);
      pick.textContent = (on ? STR.pvPicked : STR.pvPick).replace('__N__', activeSlot + 2);
    }

    /* Photo déjà chargée en attendant les autres : la fenêtre s'ouvre sans blanc. */
    var first = pvThumb ? pvThumb.querySelector('img') : null;
    pvRender(first ? [first.currentSrc || first.src] : [], title);

    pv.hidden = false;
    document.documentElement.classList.add('pack-pv-open');
    var closeBtn = pv.querySelector('.pack-pv__close');
    if (closeBtn) closeBtn.focus();

    pvImages(handle).then(function (imgs) {
      if (pvHandle === handle && !pv.hidden && imgs.length) pvRender(imgs, title);
    });
  }

  function pvClose() {
    if (!pv || pv.hidden) return;
    pv.hidden = true;
    pvHandle = '';
    document.documentElement.classList.remove('pack-pv-open');
    if (pvLastFocus && document.contains(pvLastFocus)) pvLastFocus.focus();
  }

  /* ---------- affordance de défilement ----------
     Sur mobile la barre de scroll native est invisible : sans signal explicite,
     rien n'indique qu'il reste des modèles à droite. */

  function syncScrollUi() {
    var wrap = root.querySelector('[data-pack-thumbs]');
    var nav = root.querySelector('[data-pack-nav]');
    var hint = root.querySelector('[data-pack-hint]');
    if (!wrap) return;

    var count = wrap.querySelectorAll('[data-pack-free]').length;
    var scrollable = wrap.scrollWidth - wrap.clientWidth > 4;
    var atStart = wrap.scrollLeft <= 4;
    var atEnd = wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 4;

    if (nav) nav.hidden = !(scrollable && count);
    if (hint) hint.textContent = D.strBrowse || 'Fais défiler';
    var prev = root.querySelector('[data-pack-prev]');
    var next = root.querySelector('[data-pack-next]');
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;

    wrap.classList.toggle('is-at-end', atEnd);
  }

  /* ---------- défilement à la souris ----------
     Sur ordinateur, sans trackpad, une rangée qui déborde ne se fait pas
     défiler : flèches ‹ › + glisser-déposer à la souris. Le tactile garde
     son défilement natif. */

  function scrollThumbs(dir) {
    var wrap = root.querySelector('[data-pack-thumbs]');
    if (!wrap) return;
    var step = Math.max(160, Math.round(wrap.clientWidth * 0.8));
    try { wrap.scrollBy({ left: dir * step, behavior: 'smooth' }); }
    catch (e) { wrap.scrollLeft += dir * step; }
  }

  function bindDrag() {
    var wrap = root.querySelector('[data-pack-thumbs]');
    if (!wrap || wrap.dataset.dragBound) return;
    wrap.dataset.dragBound = '1';

    var down = false, moved = false, startX = 0, startLeft = 0;

    wrap.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startLeft = wrap.scrollLeft;
    });

    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved) {
        moved = true;
        wrap.classList.add('is-dragging');
      }
      wrap.scrollLeft = startLeft - dx;
    });

    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      wrap.classList.remove('is-dragging');
    });

    /* Un glisser ne doit pas sélectionner la vignette sous le curseur au relâché. */
    wrap.addEventListener('click', function (e) {
      if (!moved) return;
      moved = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    /* Empêche le « fantôme » d'image du navigateur pendant le glisser. */
    wrap.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function bindScrollUi() {
    var wrap = root.querySelector('[data-pack-thumbs]');
    if (!wrap || wrap.dataset.scrollBound) return;
    wrap.dataset.scrollBound = '1';
    wrap.addEventListener('scroll', syncScrollUi, { passive: true });
    window.addEventListener('resize', syncScrollUi);
  }

  /* Un aller-retour discret au premier affichage mobile : c'est le signal le
     plus direct que la rangée se fait glisser. Une seule fois, et jamais si
     l'utilisateur a déjà scrollé ou demandé moins d'animations. */
  function nudgeOnce() {
    var wrap = root.querySelector('[data-pack-thumbs]');
    if (!wrap || wrap.dataset.nudged || mode === 1) return;
    if (window.innerWidth > 749) return;
    if (wrap.scrollLeft > 0 || wrap.scrollWidth - wrap.clientWidth < 40) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    wrap.dataset.nudged = '1';
    try {
      wrap.scrollTo({ left: 46, behavior: 'smooth' });
      setTimeout(function () { wrap.scrollTo({ left: 0, behavior: 'smooth' }); }, 620);
    } catch (e) { /* navigateur sans scrollTo animé : on laisse tomber */ }
  }

  function hydrateThumbs() {
    var wrap = root.querySelector('[data-pack-thumbs]');
    if (!wrap || wrap.dataset.hydrated) return;
    wrap.dataset.hydrated = '1';

    var handle = wrap.dataset.packCol;
    if (!handle) return;

    var mainHandle = D.mainHandle || '';
    var seen = {};
    wrap.querySelectorAll('[data-pack-free]').forEach(function (t) {
      if (t.dataset.handle) seen[t.dataset.handle] = 1;
    });

    fetch(cartRoot() + 'collections/' + handle + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var frag = document.createDocumentFragment();
        var added = 0;

        (data.products || []).forEach(function (p) {
          if (!p.handle || p.handle === mainHandle || seen[p.handle]) return;

          var v = null;
          for (var i = 0; i < (p.variants || []).length; i++) {
            if (p.variants[i].available) { v = p.variants[i]; break; }
          }
          if (!v) return;

          var src = p.images && p.images[0] ? p.images[0].src : null;
          if (src) src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=240';

          seen[p.handle] = 1;
          frag.appendChild(buildThumb(v.id, p.title, src, p.handle));
          added++;
        });

        if (added) wrap.appendChild(frag);
        syncThumbs();
        syncScrollUi();
      })
      .catch(function (err) {
        console.warn('[GROW pack] carrousel non complété :', err);
      });
  }

  /* ---------- ajout du pack ---------- */

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addPack(btn) {
    var mainVid = window.GROW_SELECTED_VID;
    if (!mainVid || busy) return;
    busy = true;

    /* Une ligne par variante, quantités cumulées (3 × le même modèle = 1 ligne qté 3). */
    var qty = {};
    var order = [];
    function push(vid) {
      if (!qty[vid]) { qty[vid] = 0; order.push(vid); }
      qty[vid]++;
    }
    push(mainVid);
    for (var i = 0; i < mode - 1; i++) push(picks[i] ? picks[i].vid : mainVid);

    var origHTML = btn.innerHTML;
    var origStyle = btn.getAttribute('style') || '';
    btn.innerHTML = STR.added;
    btn.style.cssText = 'background:#0F0F0F;color:#fff';

    fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: order.map(function (vid) { return { id: vid, quantity: qty[vid] }; })
      })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          btn.innerHTML = origHTML;
          btn.setAttribute('style', origStyle);
          busy = false;
          sync();
        }, 2000);
      })
      .catch(function (err) {
        /* Shopify est atomique : sur erreur, rien n'a été ajouté au panier. */
        console.error('[GROW pack] ajout du pack impossible :', err);
        btn.innerHTML = origHTML;
        btn.setAttribute('style', origStyle);
        busy = false;

        /* On ne sait pas laquelle a échoué : on retire les paires choisies
           et on revient au modèle affiché, toujours disponible ici. */
        var hadPicks = false;
        for (var j = 0; j < picks.length; j++) {
          if (!picks[j]) continue;
          hadPicks = true;
          var t = root.querySelector('[data-pack-free][data-vid="' + picks[j].vid + '"]');
          if (t) t.remove();
          picks[j] = null;
        }
        if (hadPicks && errEl) errEl.hidden = false;
        sync();
      });
  }

  /* Capture : on court-circuite addToCart() dès qu'un pack est sélectionné. */
  document.addEventListener(
    'click',
    function (e) {
      if (mode === 1) return;
      var btn = e.target.closest && e.target.closest('#gpdp-atc, #gpdp-sticky-atc');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      addPack(btn);
    },
    true
  );

  /* ---------- suivi du changement de variante ---------- */

  ['gpdpSwatch', 'gpdpSize', 'gpdpColor'].forEach(function (name) {
    var orig = window[name];
    if (typeof orig !== 'function') return;
    window[name] = function () {
      var out = orig.apply(this, arguments);
      sync();
      return out;
    };
  });

  buildNote();
  bindScrollUi();
  bindDrag();
  sync();
  setTimeout(nudgeOnce, 900);

  /* Hors du chemin critique : le carrousel est déjà utilisable avec ses 50
     premières vignettes pendant que le reste arrive. */
  if (window.requestIdleCallback) requestIdleCallback(hydrateThumbs, { timeout: 3000 });
  else setTimeout(hydrateThumbs, 1200);
})();
